<template>
    <main-container>
        <v-container class="convention-obligations-select">
            <v-row>
                <v-col cols="11">
                    <typo name="body-16-normal" v-if="conventionLeftNumber > 0">
                        Pour pouvoir accéder aux obligations de la convention collective, vous devez
                        sélectionner cette convention.
                    </typo>
                    <typo name="body-16-normal" v-if="conventionLeftNumber <= 0">
                        Votre quota de conventions est atteint. Vous devez souscrire une offre
                        supérieure pour ajouter des conventions.
                        <a href="/?anchor=offers" class="link" target="_blank">
                            <typo name="link"> Cliquez ici pour consulter nos offres </typo>
                        </a>
                    </typo>
                </v-col>
            </v-row>
        </v-container>
    </main-container>
</template>

<script>
import userMixin from "src/mixins/user";

export default {
    components: {},
    props: ["convention", "user"],
    mixins: [userMixin],
};
</script>

<style scoped lang="sass">
.convention-obligations-select
    background: $color-background
    padding: $grid-gutter * 1.5 $grid-gutter * 2
</style>
